import { render, staticRenderFns } from "./AboutMePage.vue?vue&type=template&id=5fbb72ce&scoped=true"
import script from "./AboutMePage.vue?vue&type=script&lang=js"
export * from "./AboutMePage.vue?vue&type=script&lang=js"
import style0 from "./AboutMePage.vue?vue&type=style&index=0&id=5fbb72ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbb72ce",
  null
  
)

export default component.exports